"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatesOfMonthPicker = void 0;
const toggle_1 = __importDefault(require("@opsbase/lib-general/utils/toggle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importStar(require("react"));
const NO_OF_DAYS = 31;
const NO_PER_ROW = 10;
const NO_OF_ROWS = Math.ceil(NO_OF_DAYS / NO_PER_ROW);
const DatesOfMonthPicker = (props) => {
    let { datesOfMonth, last, onChange } = props;
    const numDays = datesOfMonth === null || datesOfMonth === void 0 ? void 0 : datesOfMonth.length;
    const handleClickDay = (0, useCallforward_1.default)(v => () => {
        if (last) {
            onChange([v], false);
        }
        else {
            onChange((0, toggle_1.default)(datesOfMonth, v), false);
        }
    }, [datesOfMonth, last, onChange]);
    const handleClickLast = (0, react_1.useCallback)(() => {
        onChange(datesOfMonth, !last);
    }, [datesOfMonth, last, onChange]);
    return (react_1.default.createElement(Vertical_1.default, null,
        (0, range_1.default)(NO_OF_ROWS).map(rowN => (react_1.default.createElement(Horizontal_1.default, { alignItems: "flex-start", key: `row-${rowN}` },
            (0, range_1.default)(NO_PER_ROW)
                .map(colN => rowN * NO_PER_ROW + colN + 1)
                .filter(dayN => dayN <= NO_OF_DAYS)
                .map(dayN => {
                const isSelected = datesOfMonth.indexOf(dayN) >= 0;
                return (react_1.default.createElement(Button_1.default, { key: `day-of-month-${dayN}`, round: true, bordered: true, margin: 1, color: !last && isSelected ? lib_palette_1.default.secondary : lib_palette_1.default.White, noEvents: numDays <= 1 && isSelected, onClick: handleClickDay(dayN), label: dayN }));
            }),
            rowN === NO_OF_ROWS - 1 && (react_1.default.createElement(Button_1.default, { color: last ? lib_palette_1.default.secondary : lib_palette_1.default.LavendarGrey, margin: 1, onClick: handleClickLast }, lib_i18n_1.default.t('last')))))),
        react_1.default.createElement(Pane_1.default, { grow: true })));
};
exports.DatesOfMonthPicker = DatesOfMonthPicker;
exports.default = exports.DatesOfMonthPicker;
